const Fetcher = require('od-modules/utils/fetcher');
const trackingUtils = require('od-modules/utils/tracking.utils');
const logger = require('od-modules/utils/logger');

Odigeo.defineWidget('previoussearches', Odigeo.Widget.extend({

    modelClass: Odigeo.Model.extend({

        searches: null,
        locations: null,
        luckyLayerIsBeingShown: false,
        hasToShowLuckyLayer: false,
        searchMadeFromPreviousSearches: false,

        get: function(force) {
            const {type, filter, productPage} = this.widget.options;
            let searches;

            const getLocations = function(searches, type) {
                return Odigeo._.chain(searches)
                    .map(function(a) {
                        return a.type === 'roundTrip' ?
                            [a.searchSegments[0]] :
                            a.searchSegments;
                    })
                    .flatten()
                    .map(Odigeo._.property(type))
                    .unique(Odigeo._.property('geoNodeId'))
                    .value();
            };

            if (Odigeo._.isNull(this.searches) || force) {
                this.searches = this.getSearchesFromLocalStorage();
            }

            searches = Odigeo._.cloneDeep(this.searches);

            if (productPage === 'dynpack') {
                searches = this.getDynpackSearches();
            }

            Odigeo.trigger(this.widget.name + ':isEmpty', {
                id: this.widget.id,
                name: this.widget.name,
                empty: searches.length <= 0,
            });

            switch (type) {
                case 'ninja':
                case 'searches':
                    if (Odigeo._.isEmpty(filter)) {
                        return searches;
                    } else {
                        return Odigeo._.filter(searches, Odigeo._.matches(filter));
                    }
                case 'departure':
                case 'destination':
                    if (Odigeo._.isNull(this.locations) || force) {
                        this.locations = getLocations(searches, type);
                    }

                    return this.locations;
            }
        },

        getFlightsSearches: function() {
            return this.filterSearches(false);
        },

        getDynpackSearches: function() {
            return this.filterSearches(true);
        },

        filterSearches: function(isDynpack) {
            return Odigeo._.filter(this.searches, Odigeo._.bind(function(prevSearch) {
                return isDynpack === this.isDynpackSearch(prevSearch);
            }, this));
        },

        isDynpackSearch: function(search) {
            return Odigeo._.has(search, 'rooms');
        },

        getSearchesFromLocalStorage: function() {
            const raw = Odigeo.Storage.get('search-data');
            let data;

            if (!Odigeo._.isNull(raw)) {
                try {
                    data = JSON.parse(raw);
                } catch (error) {
                    logger.error(error);
                    data = [];
                }
            } else {
                data = [];
            }
            const today = Odigeo.Utils.getToday();
            data = Odigeo._.filter(data, function(search) {
                let date;
                return search.searchSegments.length > 0 &&
                    Odigeo._.isDate(date = Odigeo.Utils.parseDate(search.searchSegments[0].dateStr)) &&
                    date.getTime() >= today;
            });

            return data;
        },

        setHasToShowLuckyLayer: function() {
            const searches = this.get();
            const firstSearch = searches.length === 0;
            const {showLuckyLayer} = this.widget.options;

            if (showLuckyLayer) {
                this.hasToShowLuckyLayer = firstSearch;
            }
        },

        add: function(search) {
            let searches = this.getSearchesFromLocalStorage();
            search.creationDate = new Date().getTime();
            const {
                maxStored,
                hasBubbleNotification,
            } = this.widget.options;

            if (Odigeo.AB.getPriceTrends < Odigeo.Utils.Partition.C) {
                const simple = this.extractFieldsForSearchComparison(search);
                search.priceTrend = Odigeo._.union(search.priceTrend, Odigeo._.chain(searches)
                    .find(function(item) {
                        return this.extractFieldsForSearchComparison(item) === simple;
                    }, this)
                    .get('priceTrend')
                    .value());
            }

            searches.unshift(Odigeo._.omit(search, ['buyPath', 'airlinesCodes']));

            const searchesSizeBefore = searches.length;
            searches = Odigeo._.uniq(searches, this.extractFieldsForSearchComparison, this);
            const isExistingSearch = (searchesSizeBefore - searches.size) >= 1;
            searches = Odigeo._.take(searches, maxStored);

            if (hasBubbleNotification && !this.hasToShowLuckyLayer) {
                this.widget.view.updateBubbleCount();
            }

            if (!isExistingSearch) {
                this.save(searches);
                const searchToAdd = Odigeo._.cloneDeep(search);
                for (let searchSegmentIndex in search.searchSegments) {
                    if (Odigeo._.has(search.searchSegments, searchSegmentIndex)) {
                        searchToAdd.searchSegments[searchSegmentIndex].departure = search.searchSegments[searchSegmentIndex].departure.iata;
                        searchToAdd.searchSegments[searchSegmentIndex].destination = search.searchSegments[searchSegmentIndex].destination.iata;
                        searchToAdd.searchSegments[searchSegmentIndex].segmentOrder = searchSegmentIndex;
                    }
                }
                Odigeo.trigger(this.widget.name + ':addMultiDeviceSearch', {searchToAdd: searchToAdd, searches: searches});
            }
        },

        addPriceLastSearch: function(price) {
            const searches = this.getSearchesFromLocalStorage();

            if (Odigeo._.get(searches, '[0].searchSegments')) {
                searches[0].cheapestItineraryPrice = price;
                searches[0].cheapestItineraryPriceTimestamp = new Date().getTime();

                if (Odigeo.AB.getPriceTrends < Odigeo.Utils.Partition.C) {
                    const priceTrend = searches[0].priceTrend || [];
                    priceTrend.push({
                        price: price,
                        timestamp: searches[0].cheapestItineraryPriceTimestamp,
                        dates: Odigeo._.map(searches[0].searchSegments, 'dateStr'),
                    });
                    searches[0].priceTrend = priceTrend;

                    Odigeo.trigger('previoussearches:priceTrendsUpdated', priceTrend);
                }

                this.save(searches);
            }
        },

        clear: function() {
            this.save([]);
        },

        save: function(searches) {
            Odigeo.Storage.set('search-data', JSON.stringify(searches));
            Odigeo.trigger(this.widget.name + ':reload');
        },

        getLocationsFromGeoService: function(searches) {
            const query = Odigeo._.map(searches, function(search) {
                return Odigeo._.map(search.searchSegments, function(searchSegment) {
                    return 'iatas=' + searchSegment.departure + ';iatas=' + searchSegment.destination;
                }).join(';');
            }).join(';');

            return Fetcher.get(Odigeo.Settings.options.geoServiceUrlFormatter('locations') + ';' + query + ';').json();
        },

        mapSearchModels: function(searches, locationsMap) {
            for (let searchIndex in searches) {
                if (Odigeo._.has(searches, searchIndex)) {
                    let search = searches[searchIndex];
                    search.internalSearch = true;
                    search.fromUserAccount = true;
                    if (Odigeo._.isNull(search.cabinClass)) {
                        search = Odigeo._.omit(search, ['cabinClass']);
                    }
                    for (let searchSegmentIndex in search.searchSegments) {
                        if (Odigeo._.has(search.searchSegments, searchSegmentIndex)) {
                            search.searchSegments[searchSegmentIndex] = this.
                                mapSearchSegmentModels(search.searchSegments[searchSegmentIndex], locationsMap);
                        }
                    }
                    searches[searchIndex] = search;
                }
            }
            return searches;
        },

        mapSearchSegmentModels: function(searchSegment, locationsMap) {
            const segmentExtended =
            {
                dateStr: Odigeo.Utils.formatDate(searchSegment.dateStr, 'isoDate', true),
                departure: this.getLocationByIATA(searchSegment.departure, locationsMap),
                destination: this.getLocationByIATA(searchSegment.destination, locationsMap),
            };
            return Odigeo._.omit(Odigeo._.extend(searchSegment, segmentExtended), ['segmentOrder']);
        },

        getLocationByIATA: function(IATA, locationsMap) {
            const location = locationsMap[IATA];
            location.geoNodeType = location.type;
            location.matchType = location.type;
            return Odigeo._.omit(location, ['coordinates', 'locationNames']);
        },

        updateLocationsMap: function(locations) {
            const locationsMap = {};
            Odigeo._.each(locations, function(location) {
                locationsMap[location.iata] = location;
            });
            return locationsMap;
        },

        mergeSearches: function(searches) {
            const allSearches = Odigeo._.sortByOrder(searches.concat(this.searches), function(search) {
                return search.creationDate || 0;
            }, ['desc']);
            this.searches = Odigeo._.take(Odigeo._.uniq(allSearches, this.extractFieldsForSearchComparison, this), this.widget.options.maxStored);
        },

        extractFieldsForSearchComparison: function(search) {
            return JSON.stringify({
                type: search.type,
                rooms: search.rooms,
                numberOfRooms: search.numberOfRooms,
                searchSegmentsLength: search.searchSegments.length,
                searchSegments: Odigeo._.map(search.searchSegments, function(segment) {
                    return {
                        departure: segment.departure.geoNodeId,
                        destination: segment.destination.geoNodeId,
                    };
                }, this),
            });
        },

        setMultiDeviceSearches: function(searches) {
            this.getLocationsFromGeoService(searches).then(Odigeo._.bind(function(locations) {
                searches = this.mapSearchModels(searches, this.updateLocationsMap(locations));
                this.mergeSearches(searches);
                if (!Odigeo._.isEmpty(searches)) {
                    this.save(this.searches);
                }
                this.widget.view.render();
            }, this));
        },

    }),

    viewClass: Odigeo.View.extend({

        init: function() {
            if (this.widget.options.type !== 'ninja') {
                Odigeo._.templateSettings = Odigeo.Utils.getTmplSettings({variable: ''});

                this.cacheDomSelectors();
            }
        },

        events: {
            'tap .ps_clear_all': 'clearHandler',
            'tap .ps_container .ps_row': 'selectHandler',
            'tap .ps_container button': 'selectHandler',
            'tap .ps_container .ps_expand': 'expandHandler',
        },

        selectors: {
            wrapper: '.ps_wrapper',
            container: '.ps_container',
            header: '.ps_title',
            clearBtn: '.ps_clear_all',
            passengers: '.ps_passenger',
            cityLogos: '.ps_city_logo',
        },

        cacheDomSelectors: function() {
            const $templateEmpty = this.$widget.find('.ps_template_empty').html();
            const $templateLucky = this.$widget.find('.ps_template_lucky').html();

            this.template = Odigeo._.template(this.$widget.find('.ps_template').html());
            this.templateList = Odigeo._.template(this.$widget.find('.ps_template_list').html());

            if (!Odigeo._.isUndefined($templateEmpty)) {
                this.templateEmpty = Odigeo._.template($templateEmpty);
            }

            if (!Odigeo._.isUndefined($templateLucky)) {
                this.templateLucky = Odigeo._.template($templateLucky);
            }
        },

        render: function() {
            let data = this.widget.model.get();
            const {
                type,
                max,
                rtAsOw,
                joinedLegs,
                contractMultipleTrip,
                suggestedRecentDestinationsMixed,
                showEmptyLayer,
                folded,
            } = this.widget.options;

            data = Odigeo._.take(data, max);

            if (type === 'searches') {
                data = Odigeo._.map(data, function(item) {
                    let differenceInDays;
                    let datesStr;
                    const itemProduct = this.model.isDynpackSearch(item) ? 'dynpack' : 'flights';
                    let segments = Odigeo._.map(item.searchSegments, function(leg) {
                        return [leg.departure, leg.destination];
                    });
                    let dates = Odigeo._.map(item.searchSegments, this.widget.parseDate);
                    const fromNow = item.cheapestItineraryPriceTimestamp && Odigeo.Utils.fromNow(item.cheapestItineraryPriceTimestamp);

                    if (rtAsOw && item.type === 'roundTrip') {
                        segments = [segments[0]];
                    }

                    if (joinedLegs && item.type === 'multipleTrip') {
                        const legs = [];

                        Odigeo._.each(segments, function(leg, idx, arr) {
                            if (legs.length > 0 && arr[idx][0].geoNodeId === arr[idx - 1][1].geoNodeId) {
                                const lastLeg = legs.pop();
                                lastLeg.push(leg[1]);
                                legs.push(lastLeg);
                            } else {
                                legs.push(leg);
                            }
                        });

                        if (contractMultipleTrip) {
                            segments = [
                                [Odigeo._.first(Odigeo._.first(legs)), Odigeo._.last(Odigeo._.last(legs))],
                            ];
                            dates = [Odigeo._.first(dates), Odigeo._.last(dates)];
                        } else {
                            segments = legs;
                        }
                    }

                    if (itemProduct === 'dynpack') {
                        datesStr = Odigeo._.map(item.searchSegments, function(segment) {
                            return Odigeo.Utils.parseDate(segment.dateStr);
                        });
                        differenceInDays = Odigeo.Utils.getDifferenceInDays(datesStr[0], datesStr[1]);
                    }

                    return {
                        numAdults: item.numAdults,
                        numChildren: item.numChildren,
                        numInfants: item.numInfants,
                        paxs: item.numAdults + item.numChildren + item.numInfants,
                        differenceInDays: differenceInDays,
                        segments: segments,
                        dates: dates,
                        type: item.type,
                        contractMultipleTrip: contractMultipleTrip,
                        fromNow: fromNow,
                        cheapestItineraryPrice: Odigeo.Utils.formatCurrency(item.cheapestItineraryPrice),
                        creationDate: item.creationDate,
                        product: itemProduct,
                    };
                }, this);
            }

            if (suggestedRecentDestinationsMixed) {
                Odigeo.trigger('last-destination-searches:suggestedRecentDestinationsMixed', {
                    citiesList: data,
                    id: this.widget.id[this.widget.id.length-1],
                });
            } else {
                const pieces = Odigeo._.map(data, this.template);
                const html = pieces.length === 0 && showEmptyLayer &&
                    Odigeo._.isFunction(this.templateEmpty) ? this.templateEmpty() :
                    this.templateList({
                        data: pieces,
                        folded: folded,
                    });

                this.$cachedSelectors.container
                    .empty()
                    .html(html);

                if (data.length > 0) {
                    this.setCityLogos();
                }

                this.$cachedSelectors.wrapper.toggleClass('odf-hidden', this._isPreviousSearchesDisplayable(data));

                this.renderPassengers();

                this.widget.model.luckyLayerIsBeingShown = false;
            }
        },

        _isPreviousSearchesDisplayable: function(data) {
            const {isAnywhereEnabled, showEmptyLayer} = this.widget.options;
            return isAnywhereEnabled || showEmptyLayer ? false : !data.length;
        },

        renderPassengers: function() {
            const $parentContainer = this.$cachedSelectors.container.parent();
            const $container = this.$cachedSelectors.container.detach();
            const $passengersContainers = $container.find(this.selectors.passengers);
            let texts;

            $passengersContainers.each(function(index, el) {
                const $el = $(el);
                const passengers = [
                    $el.data('adults'),
                    $el.data('children'),
                    $el.data('infants'),
                ];
                texts = Odigeo._.chain(passengers)
                    .map(function(elem) {
                        if (!elem || elem.length < 2 || elem[0] === '0') {
                            return false;
                        }
                        return Odigeo.Utils.processCmsPlaceholder(elem[0], elem[1]);
                    })
                    .compact()
                    .value();
                $el.html(texts.join(', '));
            });
            $parentContainer.append($container);
        },

        selectHandler: function(e) {
            const $el = $(e.currentTarget);
            const {recentSearchesDPTracking, type, trackingId} = this.widget.options;
            const itemId = $el.data('id');
            const data = this.widget.model.get();
            const page = this.widget.id.indexOf('header') > 0 ? 'header' : Odigeo.History.getPageNameFromFragment();
            const label = recentSearchesDPTracking ? this.getRecentSearchesDPTrackingLabel($el) : this.getTrackingLabel(itemId);

            trackingUtils.trackEvent('recent_search' + (!Odigeo._.isUndefined(trackingId) ? '_' + trackingId : ''), label, page);
            switch (type) {
                case 'searches':
                    Odigeo.trigger(this.widget.id + ':rowSelected', data[itemId]);
                    $('.airportselector_root').removeAttr('data-state');
                    break;
                case 'departure':
                case 'destination':
                    Odigeo.trigger('lastAirports:rowSelected', {
                        dataSearch: data[itemId],
                        type: type,
                        id: this.widget.id,
                    });
                    break;
            }
        },

        getRecentSearchesDPTrackingLabel: function($el) {
            let label;
            let hasDifferentProducts;
            const itemId = $el.data('id');
            const product = $el.find('.ps_city_logo').data().product;
            const {productPage} = this.widget.options;
            const allProducts = [product];
            $el.siblings('.ps_row,.ps_folded').each(function() {
                allProducts.push($(this).find('.ps_city_logo').data().product);
            });

            label = 'search_recent_' + product + '_' + (itemId + 1);
            if (productPage === 'flights') {
                hasDifferentProducts = Odigeo._.uniq(allProducts).length > 1 ? 'YES' : 'NO';
                label += '_both:' + hasDifferentProducts;
            }
            return label;
        },

        getTrackingLabel: function(itemId) {
            return 'search_recent_' + (itemId + 1);
        },

        clearHandler: function() {
            let popup;
            const {
                confirm_prevsearch_confirm: {confirmPrevsearchConfirm},
                confirm_prevsearch_cancel: {confirmPrevsearchCancel},
                confirm_prevsearch_title: {confirmPrevsearchTitle},
                confirm_prevsearch_description: {confirmPrevsearchDescription},
                productPage,
            } = this.widget.options;
            const deleteBtn = {
                text: confirmPrevsearchConfirm,
                style: 'od-ui-dialog-button-default',
                handler: Odigeo._.bind(function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (productPage === 'dynpack') {
                        this.widget.save(this.model.getFlightsSearches());
                    } else {
                        this.widget.clear();
                    }
                    Odigeo.UIElements.hideDialog(popup);
                }, this),
            };
            const cancelBtn = {
                text: confirmPrevsearchCancel,
                style: 'od-ui-dialog-button-cancel',
                handler: function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    Odigeo.UIElements.hideDialog(popup);
                },
            };

            popup = Odigeo.UIElements.createDialog(
                confirmPrevsearchTitle,
                confirmPrevsearchDescription,
                [cancelBtn, deleteBtn]);

            Odigeo.UIElements.showDialog(popup);

            trackingUtils.trackEvent('recent_search', 'close_recent_search');
        },

        expandHandler: function(e) {
            e.preventDefault();
            this.$cachedSelectors.container.toggleClass('expanded');
            if (this.$cachedSelectors.container.hasClass('expanded')) {
                trackingUtils.trackEvent('recent_search', 'open_view_more');
            }
        },

        showLuckyLayer: function() {
            this.$cachedSelectors.container
                .empty()
                .html(this.templateLucky());

            this.widget.model.luckyLayerIsBeingShown = true;
        },

        updateBubbleCount: function(count) {
            if (!this.widget.model.searchMadeFromPreviousSearches && this.widget.options.hasBubbleNotification) {
                const bubbleCount = Odigeo._.isUndefined(count) ?
                    Odigeo._.min([this.widget.options.max, this.widget.model.get().length]) :
                    count;

                this.widget.$bubbleNotification.trigger('updateCount', bubbleCount);
            } else {
                this.widget.model.searchMadeFromPreviousSearches = false;
            }
        },

        setCityLogos: function() {
            $(this.widget.view.selectors.cityLogos).each(Odigeo._.bind(function(index, city) {
                this.setProductLogo(city);
            }, this));
        },

        setProductLogo: function(city) {
            const $div = $('<div />');
            const product = $(city).attr('data-product');
            const productClass = 'odf-icon-flight' + (product === 'dynpack' ? '-hotel' : '');
            $div.addClass('odf-icon odf-icon-2xl ' + productClass + ' od-previousSearches-product-icon');
            $(city).addClass('od-previousSearches-city-logo od-previousSearches-product-border');
            $(city).html($div);
        },

        setLocationLogo: function(city) {
            const cityName = $(city).attr('data-city');
            const iataCode = $(city).attr('data-iata');
            const imagePath = $(city).attr('data-path');
            const img = new Image();

            img.alt = cityName;
            img.onerror = function() {
                img.src = imagePath + 'XXX.jpg';
            };
            img.src = imagePath + iataCode + '.jpg';
            img.className = 'odf-img-circle od-previousSearches-city-logo';
            $(city).html(img);
        },

        toggle: function(show) {
            return this.$cachedSelectors.wrapper.toggleClass('odf-hidden', !show || this.widget.options.suggestedRecentDestinationsMixed);
        },

    }),

    init: function() {
        const defaults = {
            folded: 0,
            max: 10,
            rtAsOw: true,
            joinedLegs: false,
            maxStored: 50,
            dateFormat: 'UTC:d mmm',
        };

        this.options = Odigeo._.extend(defaults, Odigeo.Utils.parseOptions(this.options));

        if (this.options.folded === 0) {
            this.options.folded = Infinity;
        }
        if (this.options.max === 0) {
            this.options.max = Infinity;
        }

        this.parseDate = Odigeo._.flowRight(Odigeo._.partial(Odigeo.Utils.formatDate, _, this.options.dateFormat, true),
            Odigeo.Utils.parseDate,
            Odigeo._.property('dateStr'));

        this.bindEvents();

        if (this.options.type !== 'ninja') {
            this.view.render();
        }

        if (this.options.hasBubbleNotification) {
            this.$bubbleNotification = Odigeo.UIElements.enhanceBubbleNotification($('#header').find('.header_previoussearches_bubble'));
            this.view.updateBubbleCount();
        }
    },

    parseDate: null,

    bindEvents: function() {
        Odigeo.on(this.name + ':reload', Odigeo._.bind(this.reload, this));
        Odigeo.on('search-manager:updateLastSearchPrice', Odigeo._.bind(this.updateLastSearchPrice, this));
    },

    clear: function() {
        const data = this.model.getSearchesFromLocalStorage();
        const searchIdData = Odigeo._.compact(Odigeo._.pluck(data, 'searchId'));

        if (!Odigeo._.isEmpty(searchIdData)) {
            Odigeo.trigger(this.id + ':requestDeleteMultideviceSearches', searchIdData);
        }
        this.model.clear();
    },

    add: function(search) {
        this.model.add(search);
    },

    updateLastSearchPrice: function(price) {
        if (this.options.hasToShowPrice) {
            this.model.addPriceLastSearch(price);
        }
    },

    reload: function() {
        this.model.get(true);
        if (this.options.type !== 'ninja') {
            this.view.render();
        }
    },

    filter: function(filter) {
        this.options.filter = filter || {};
        this.reload();
    },

    retrieveLastSearch: function(key) {
        const searches = this.model.get();
        if (searches.length > 0) {
            Odigeo.PageStorage.set(key, JSON.stringify(searches[0]));
        }
    },

    hideBubbleNotification: function() {
        if (this.options.hasBubbleNotification) {
            this.$bubbleNotification.trigger('hideBubble');
        }
    },

    hasPreviousSearches: function() {
        return this.model.get('searches').length > 0;
    },

    setMultiDeviceSearches: function(searches) {
        if (!Odigeo._.isEmpty(searches)) {
            this.model.setMultiDeviceSearches(searches);
        }
    },

    cleanSearchFromAccount: function() {
        const data = this.model.getSearchesFromLocalStorage();
        Odigeo._.remove(data, function(search, index) {
            return search.fromUserAccount && index;
        });
        Odigeo.Storage.set('search-data', JSON.stringify(data));
        Odigeo.trigger(this.name + ':reload');
    },

    save: function(searches) {
        this.model.save(searches);
    },

    toggle: function(params) {
        return this.view.toggle(!params.isMaximum);
    },

    execute: function(fn) {
        const args = [].slice.call(arguments, 1);

        switch (fn) {
            case 'add':
            case 'storeData':
                this.add.apply(this, args);
                break;
            case 'clear':
            case 'removeData':
                this.clear.apply(this, args);
                break;
            case 'reload':
                this.reload.apply(this, args);
                break;
            case 'retrieveLastSearch':
                this.retrieveLastSearch.apply(this, args);
                break;
            case 'filter':
                this.filter.apply(this, args);
                break;
            case 'showLuckyLayer':
                this.view.showLuckyLayer.apply(this.view, args);
                break;
            case 'isLuckyLayerBeingShown':
                return this.model.luckyLayerIsBeingShown;
            case 'hasToShowLuckyLayer':
                return this.model.hasToShowLuckyLayer;
            case 'setHasToShowLuckyLayer':
                this.model.setHasToShowLuckyLayer.apply(this.model, args);
                break;
            case 'updateBubbleCount':
                this.view.updateBubbleCount.apply(this.view, args);
                break;
            case 'hideBubbleNotification':
                this.hideBubbleNotification();
                break;
            case 'hasPreviousSearches':
                return this.hasPreviousSearches.apply(this, args);
            case 'searchMadeFromPreviousSearches':
                this.model.searchMadeFromPreviousSearches = true;
                break;
            case 'setMultiDeviceSearches':
                this.setMultiDeviceSearches.apply(this, args);
                break;
            case 'persistSearches':
                this.save.apply(this, args);
                break;
            case 'cleanSearchFromAccount':
                this.cleanSearchFromAccount();
                break;
            case 'toggle':
                this.toggle.apply(this, args);
                break;
        }

        return this;
    },
}));
